import Api from '../api'

export default ({

  state: {
    costCenterLists: [],
    costCenterGroupListsDropdown: [],
    costCenterSubGroupListsDropdown: [],
    costCenterTree: [],
    costCenterForTransactionLists: [],
    costCenterLedgerLists: [],
    costCenterSummaryLists: []
  },
  mutations: {
    COST_CENTER_LEDGER_LIST(state, costCenterLedgerList) {
      state.costCenterLedgerLists = costCenterLedgerList
    },
    ADD_COST_CENTER (state, costCenterList) {
      let costCenter = state.costCenterLists.concat(costCenterList)
    //   console.log(itemgroup)
      state.costCenterLists = costCenter
    //   console.log(state.itemgroups)
    },
    SET_COST_CENTER (state, costCenterList) {
      state.costCenterLists = costCenterList
    },
    UPDATE_COST_CENTER(state, updateCostCenter) {
      state.costCenterLists = state.costCenterLists.map(costCenter => costCenter.id !== updateCostCenter.id ? costCenter : {...costCenter, ...updateCostCenter})
    },
    DELETE_COST_CENTER (state, coCenter) {
      let costCenter = state.costCenterLists.filter(a => a.id !== coCenter.id)
      state.costCenterLists = costCenter
    },
    SET_COST_CENTER_DROPDOWN(state, costCenter) {
      state.costCenterGroupListsDropdown = costCenter
    },
    SET_COST_CENTER_SUBGROUP_DROPDOWN(state, costCenter) {
      state.costCenterSubGroupListsDropdown = costCenter
    },
    SET_COST_CENTER_TREE(state, costCenter) {
      state.costCenterTree = costCenter
    },
    SET_COST_CENTER_FOR_SUMMARY(state, costCenterSummaryList) {
      state.costCenterSummaryLists = costCenterSummaryList
    },
    SET_COST_CENTER_FOR_TRANSACTION(state, costCenterForTransactionList) {
      state.costCenterForTransactionLists = costCenterForTransactionList
    }
  },
  actions: {
    async createCostCenter({commit}, costCenter) {
      let response = await Api.request('post', '/costCenter/createCostCenter/' + this.state.organisationid + '/' + this.state.user.id, costCenter)
      let costCent = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_COST_CENTER', costCent)
      }
      return response
    },
    async loadCostCenter({commit}) {
      let response = await Api.request('get', '/costCenter/costCenterList/' + this.state.organisationid, null)
      commit('SET_COST_CENTER', response.data.data)
      return response
    },
    async deleteCostCenter({commit}, deleteRea) {
      let response = await Api.request('delete', '/costCenter/deleteCostCenter/' + deleteRea.costCenterId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let purchaseSundary = response.data.data
      commit('DELETE_PURCHASE_SUNDARY', purchaseSundary)
      return response
    },
    async updateCostCenter({commit}, costCenter) {
      let resp = await Api.request('put', '/costCenter/costCenterMaster/' + costCenter.id, costCenter)
      commit('UPDATE_PURCHASE_SUNDARY', resp.data.data)
      return resp
    },
    async loadCostCenterGroupDropdown({commit}) {
      let response = await Api.request('get', '/costCenter/costCenterListForDropdown/' + this.state.organisationid, null)
      commit('SET_COST_CENTER_DROPDOWN', response.data.data)
      return response
    },
    async loadCostCenterSubGroupDropdown({commit}, costCenter) {
      let response = await Api.request('get', '/costCenter/costCenterListByParentId/' + this.state.organisationid + '/' + costCenter.id, null)
      commit('SET_COST_CENTER_SUBGROUP_DROPDOWN', response.data.data)
      return response
    },
    async loadCostCenterForTree({commit}) {
      let response = await Api.request('get', '/costCenter/costCenterListTree/' + this.state.organisationid, null)
      commit('SET_COST_CENTER_TREE', response.data.data)
      return response
    },
    async loadCostCenterForSummaryReport({commit}, toDate) {
      let response = await Api.request('get', '/costCenter/costCenterSummaryReport/' + this.state.organisationid + '/' + this.state.fyId + '/' + toDate, null)
      commit('SET_COST_CENTER_FOR_SUMMARY', response.data.data)
      return response
    },
    async loadCostCenterForTransaction({commit}) {
      let response = await Api.request('get', '/costCenter/costCenterListForDropdownForTransaction/' + this.state.organisationid, null)
      commit('SET_COST_CENTER_FOR_TRANSACTION', response.data.data)
      return response
    },
    async loadCostCenterLedgerList ({commit}, ledger) {
      let response = await Api.request('get', '/costCenter/costCenterLedger/' + this.getters.organisationId + '/' + this.state.fyId + '/' + ledger.costCenterId + '/' + ledger.fromDate + '/' + ledger.toDate)
      let responseValue = response.data.data
      commit('COST_CENTER_LEDGER_LIST', responseValue)
      return response
    }
  },
  getters: {

  }
})



// WEBPACK FOOTER //
// ./src/store/costCenter.js